import {
  LayoutDashboard, BatteryCharging, PlusCircle, FileText, Users2,
  Wrench, BarChart3, ClipboardPlus, SlidersHorizontal, Database, Settings2,
} from "lucide-react";

export const ROLE_LABELS = {
  admin: "Administrator",
  backend_team: "Backend Team",
  distributor: "Distributor",
  dealer: "Dealer",
  shopkeeper: "Shopkeeper",
  sales_agent: "Sales Agent",
  service_provider: "Service Provider",
  customer: "Customer",
};

export const ALL_ROLES = Object.keys(ROLE_LABELS);

export const ADMIN_ROLES = ["admin", "backend_team"];
export const REGISTRAR_ROLES = ["admin", "backend_team", "distributor", "dealer", "shopkeeper", "sales_agent"];

export const CLAIM_TYPES = ["Replace", "Service Warranty", "Money Refund", "Physical Inspection"];

export const STATUS_META = {
  submitted: { label: "Awaiting Approval", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  approved: { label: "Approved", cls: "bg-teal-100 text-teal-800 border-teal-200" },
  service_pending: { label: "Service Pending", cls: "bg-blue-100 text-blue-800 border-blue-200" },
  service_assigned: { label: "Service Assigned", cls: "bg-blue-100 text-blue-800 border-blue-200" },
  service_completed: { label: "Service Done", cls: "bg-indigo-100 text-indigo-800 border-indigo-200" },
  replace_approved: { label: "Replacement", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  refund_approved: { label: "Refund", cls: "bg-violet-100 text-violet-800 border-violet-200" },
  inspection_scheduled: { label: "Inspection", cls: "bg-cyan-100 text-cyan-800 border-cyan-200" },
  rejected: { label: "Rejected", cls: "bg-red-100 text-red-800 border-red-200" },
  closed: { label: "Closed", cls: "bg-slate-100 text-slate-700 border-slate-200" },
};

export const RESOLUTION_LABELS = {
  replace: "Battery Replacement",
  service: "Provide Service",
  refund: "Money Refund",
  inspect: "Physical Inspection",
  reject: "Rejected",
};

export const ISSUE_TYPES = [
  "Not charging", "Reduced backup", "Physical damage", "Overheating",
  "BMS fault", "Swelling", "No power output", "Other",
];

export const REQUESTABLE_ROLES = ["customer", "shopkeeper", "dealer", "distributor", "sales_agent", "service_provider"];

export const CUSTOM_ENTITIES = [
  { key: "battery", label: "Batteries" },
  { key: "claim", label: "Claims" },
  { key: "user", label: "Users" },
  { key: "service_center", label: "Service Centers" },
];

export const FIELD_TYPES = ["text", "number", "date", "dropdown", "textarea"];

export function navForRole(role) {
  const items = [{ to: "/dashboard", label: "Dashboard", icon: LayoutDashboard }];
  if (ADMIN_ROLES.includes(role)) {
    items.push(
      { to: "/batteries", label: "Batteries", icon: BatteryCharging },
      { to: "/register-battery", label: "Register Battery", icon: PlusCircle },
      { to: "/claims", label: "Warranty Claims", icon: FileText },
      { to: "/claims/new", label: "New Claim", icon: ClipboardPlus },
      { to: "/users", label: "Users & Partners", icon: Users2 },
      { to: "/service-centers", label: "Service Centers", icon: Wrench },
      { to: "/custom-fields", label: "Custom Fields", icon: SlidersHorizontal },
      { to: "/data", label: "Import / Export", icon: Database },
      { to: "/reports", label: "Reports", icon: BarChart3 },
      { to: "/settings", label: "Settings", icon: Settings2 },
    );
  } else if (role === "service_provider") {
    items.push({ to: "/claims", label: "Assigned Services", icon: Wrench });
  } else {
    if (REGISTRAR_ROLES.includes(role)) {
      items.push(
        { to: "/batteries", label: "My Batteries", icon: BatteryCharging },
        { to: "/register-battery", label: "Register Battery", icon: PlusCircle },
      );
    }
    items.push(
      { to: "/claims", label: "My Claims", icon: FileText },
      { to: "/claims/new", label: "New Claim", icon: ClipboardPlus },
    );
  }
  return items;
}
